import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import ChartSeries from 'app/react/chart/ChartSeries.jsx';
import LineChart  from 'app/react/chart/LineChart.jsx';
//import ReportTable from 'app/react/ReportTable.jsx';

// Teaser:
// var css = $('<style>@keyframes mymove{from {left:0px;}to {left:'+pushLeft+'px;}}</style>').appendTo('head');

//make sure you don't carriage return the css inline statement, or else it'll be error as ILLEGAL



// bielany - strona do zagniezdzenia
// http://www.bielany.waw.pl/page/210,monitoring-powietrza.html
// import react and some other libs
import {
  Moment
} from 'app/react/Boot.jsx';

require('react-d3');

class Teaser extends Component {

  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return <div style={{overflow: 'hidden', width: 700, display: 'block', position: 'relative', height: 35,  fontStyle: 'italic'}}>
      <div className="bielany-teaser2" style={{height: 35, float: 'left', display: 'block', lineHeight: '35px'}}>
        {
          this.props.values.map((r, i) => {
            return <div key={i} style={{float: 'left', height: 35, marginTop: 'auto', marginBottom: 'auto', marginLeft: 20, lineHeight: '35px'}}>
              ** {r.name}: {Math.floor(r.value * 10) / 10}  {r.unit} **
            </div>
          })
        }
      </div>
      <div className="bielany-teaser" style={{height: 35, float: 'left', display: 'block', lineHeight: '35px'}}>
        {
          [1].map((p, j) => {return this.props.values.map((r, i) => {
            return <div key={p + "_" + i} style={{float: 'left', height: 35, marginTop: 'auto', marginBottom: 'auto', marginLeft: 20, lineHeight: '35px'}}>
              ** {r.name}: {Math.floor(r.value * 10) / 10} {r.unit} **
            </div>
          })})
        }
      </div>
    </div>
  }
}

export default Teaser;



// WEBPACK FOOTER //
// ./app/react/bielany/Teaser.jsx